const rbtm = {
  alarmType: 'Tipo di allarme',
  closeAlarm: 'Chiudi allarme',
  closeOpenSar: 'Chiudi e apri SAR',
  currencyCode: 'Codice valuta',
  evaluationDate: 'Data di valutazione',
  evaluationNote: 'Nota di valutazione',
  manageScenarios: 'Gestisci scenari',
  operationDate: 'Data operazione',
  operator: 'Operatore',
  rbtm: 'Rule based transaction monitor',
  rule: 'Regola',
  score: 'Punteggio',
  confirmOpenSar: 'Sei sicuro di voler chiudere l\'allarme e aprire una SAR?',
  suspiciousTransactions: 'Transazioni sospette',
  transactionDetailForEvaluation: 'Dettaglio transazione per valutazione',
  transactionParties: 'Parti della transazione',
};

export default rbtm;
